import { createContext, useState, useEffect } from "react"

// Create the context
export const ImageContext = createContext()

// Create the provider component
export const ImageProvider = ({ children }) => {
  const [images, setImages] = useState([])

  // Function to load images from sessionStorage
  const loadImagesFromSessionStorage = () => {
    const storedImages = JSON.parse(sessionStorage.getItem("images")) || []
    return storedImages.slice(0, 10)
  }

  // Function to save images to sessionStorage
  const saveImagesToSessionStorage = (newImages) => {
    sessionStorage.setItem("images", JSON.stringify(newImages))
    window.dispatchEvent(new Event("storage")) // Disparar evento manualmente
  }

  // Function to add new images
  const addImages = (newImages) => {
    setImages((prevImages) => {
      const updatedImages = [...prevImages, ...newImages].slice(0, 10)
      saveImagesToSessionStorage(updatedImages)
      return updatedImages
    })
  }

  // Function to remove an image by index
  const removeImage = (index) => {
    setImages((prevImages) => {
      const updatedImages = prevImages.filter((_, i) => i !== index)
      saveImagesToSessionStorage(updatedImages)
      return updatedImages
    })
  }

  // Function to clear all images
  const clearImages = () => {
    setImages([])
    sessionStorage.removeItem("images")
    window.dispatchEvent(new Event("storage")) // Disparar evento manualmente
  }

  // Function to reorder images
  const reorderImages = (newOrder) => {
    setImages(newOrder)
    saveImagesToSessionStorage(newOrder)
  }

  // Detect changes in sessionStorage and reload images
  useEffect(() => {
    const handleStorageChange = () => {
      const storedImages = loadImagesFromSessionStorage()
      setImages(storedImages)
    }

    window.addEventListener("storage", handleStorageChange)
    handleStorageChange() // Load images initially

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  return (
    <ImageContext.Provider value={{ images, addImages, removeImage, clearImages, reorderImages }}>
      {children}
    </ImageContext.Provider>
  )
}
